import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-910af536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flags-container d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "FR", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "EN", -1))
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flag fr", { 'active': $options.isActive('fr') }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onLanguageFlagClick('fr')))
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("img", {
        alt: "France flag",
        src: require('@/assets/images/fr.svg')
      }, null, 8, _hoisted_3), [
        [_vShow, $options.isActive('fr')]
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["flag ca", { 'active': $options.isActive('en') }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.onLanguageFlagClick('en')))
    }, [
      _hoisted_4,
      _withDirectives(_createElementVNode("img", {
        alt: "Canada flag",
        src: require('@/assets/images/ca.svg')
      }, null, 8, _hoisted_5), [
        [_vShow, $options.isActive('en')]
      ])
    ], 2)
  ]))
}